import React from 'react';
import moment from 'moment';
import {Radio, Calendar, Cell, Input, Toast} from 'zarm';
import {ShowMediaCell} from '@wap/components';
import {Observable} from '@utils';
import './index.less';
// 下次复查时间
class NextTreatExamItem extends React.Component {
  constructor(props) {
    super(props);
    const {data} = props;
    const {examContent = {}, examFiles = []} = data;
    const {nextReturnVisitDate = '', handlingOpinions = ''} = examContent;

    this.state = {
      date: nextReturnVisitDate,
      submitMediaParams: examFiles,
      submitParams: handlingOpinions,
      radioValue: '',
    };
  }

  // 快捷时间选择
  onChangeRadio(radioValue) {
    const date = [
      moment().add(1, 'days'),
      moment().add(1, 'week'),
      moment().add(1, 'month'),
      moment().add(2, 'month'),
      moment().add(3, 'month'),
    ][+radioValue];
    this.setState({date, radioValue});
  }
  // 音视频数据改变
  onMediaChange = (record) => {
    this.setState({
      submitMediaParams: record,
    });
  };
  // 日期选择
  onChangeDate(value) {
    const date = new Date(value);
    this.setState({date, radioValue: ''});
  }
  // 数据处理
  handleResult() {
    const {date, submitParams, submitMediaParams} = this.state;
    const {data} = this.props;
    const param = {
      ...data,
      examFiles: submitMediaParams,
      examContent: {
        nextReturnVisitDate: date
          ? moment(date).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD'),
        handlingOpinions: submitParams,
      },
    };
    return param;
  }

  // 值修改
  changeText = (val) => {
    this.setState({
      submitParams: val,
    });
  };

  componentDidMount() {
    const {examContent, examFiles} = this.props.data;

    this.setState({
      submitParams: examContent.handlingOpinions,
      submitMediaParams: examFiles,
    });

    // 图片查看器，图片查看器的touchmove会穿透
    // 导致tabs也跟着切换
    // 利用自定义事件发布订阅解决这个问题
    this.unSubscriber = Observable.subscribe('swipe', (visible) => {
      if (visible) {
        this.currentTabKey = this.state.tabKey;
      } else {
        document
          .querySelectorAll('.examItemTabCont .za-tabs__tab')
          .forEach((dom, index) => {
            if (this.currentTabKey === index) {
              dom.click();
            }
          });
      }
    });
  }

  render() {
    const {date, radioValue, submitMediaParams = [], submitParams} = this.state;
    const today = moment(new Date()).format('YYYY-MM-DD');

    return (
      <div className="nextTreatExamContent">
        <div className="radioContent">
          <div>复诊时间</div>
          &nbsp;
          <Radio.Group
            type="button"
            value={radioValue}
            onChange={(value) => this.onChangeRadio(value)}
          >
            <Radio value="0">明天</Radio>
            <Radio value="1">一周后</Radio>
            <Radio value="2">一月后</Radio>
            <Radio value="3">2个月后</Radio>
            <Radio value="4">3个月后</Radio>
          </Radio.Group>
        </div>
        <Calendar
          value={date}
          disabledDate={(date) => {
            if (today === moment(date).format('YYYY-MM-DD')) {
              return true;
            } else {
              return false;
            }
          }}
          onChange={(value) => this.onChangeDate(value)}
        />

        <div className="content">
          <div className="other">其他</div>
          <Cell>
            <Input
              rows={5}
              maxLength={200}
              type="text"
              value={submitParams}
              placeholder="请输入"
              onChange={(e) => this.changeText(e)}
            />
          </Cell>

          <ShowMediaCell
            {...this.props}
            fileEyeType={0}
            max={10}
            data={submitMediaParams}
            onSuccess={(record) => this.onMediaChange(record)}
          />
          <ShowMediaCell
            {...this.props}
            max={3}
            mediaType="1" // 音视频类型 0-视频图片 1-音频 默认:0
            fileEyeType={0} // 类别 1-od;2-os
            title="语音" // title; 默认:图片和视频
            data={submitMediaParams} // 音视频数据 examFiles字段
            onSuccess={(record) => this.onMediaChange(record)} // 删除和添加成功回调 返回处理后的音视频list
          />
        </div>
      </div>
    );
  }
}

export default NextTreatExamItem;
